export const roleNameMaxLength = 50;
export const teamNameMaxLength = 150;
export const groupComponentsMinLength = 1;
export const ionNumberMaxLength = 30;
export const ionNumberDescriptionMaxLength = 150;
